import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAgency'

// LIST ALL Projects
export const projectList = (params = '') => Http.get(`/mundo-indie-projects${serialize(params)}`)
export const projectCreate = (params = '') => Http.post('/mundo-indie-projects', params)
export const projectByID = (params = '') => Http.get(`/mundo-indie-projects/${params}`)
export const projectUpdate = (params = '') => Http.put(`/mundo-indie-projects/${params.id}`, params)
export const projectDestroy = (params = '') => Http.delete(`/mundo-indie-projects/${params.id}`)

// Onboarding link of the studio that sent the form: create it, e-mail it (send_email) or just fetch it.
export const projectOnboardingInvite = (id, params = {}) => Http.post(`/mundo-indie-projects/${id}/onboarding-invite`, params)
export const projectOnboardingInviteRevoke = inviteId => Http.post(`/admin/onboarding-invites/${inviteId}/revoke`)
